import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const HseSubmitDialog: React.FC<{
  open: boolean;
  weekLabel: string;
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}> = ({ open, weekLabel, busy, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={busy ? undefined : onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{t('hse.submit.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('hse.submit.body', { week: weekLabel })}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={busy}>
          {t('common.cancel')}
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={busy}>
          {t('hse.submit.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const HseReopenDialog: React.FC<{
  open: boolean;
  weekLabel: string;
  busy: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}> = ({ open, weekLabel, busy, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');
  const valid = reason.trim().length >= 3;
  return (
    <Dialog
      open={open}
      onClose={busy ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      TransitionProps={{ onExited: () => setReason('') }}
    >
      <DialogTitle>{t('hse.reopen.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>{t('hse.reopen.body', { week: weekLabel })}</DialogContentText>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={2}
          label={t('hse.reopen.reason')}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          inputProps={{ maxLength: 500 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={busy}>
          {t('common.cancel')}
        </Button>
        <Button variant="contained" onClick={() => onConfirm(reason.trim())} disabled={busy || !valid}>
          {t('hse.reopen.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
